import toast from "react-hot-toast"
import axios from "axios"
import { getCurrentBranch } from "helpers/auth-helper"

export const getIsAdmin = () => {
    const is_admin = localStorage.getItem('is_admin')
    return is_admin ?? 0
}

export const setIsAdmin = (is_admin) => {
    localStorage.setItem('is_admin', is_admin)
}

export const removeIsAdmin = () => {
    localStorage.removeItem('is_admin')
}

export const getIsSupervisor = () => {
    const is_supervisor = localStorage.getItem('is_supervisor')
    return is_supervisor ?? 0
}

export const setIsSupervisor = (is_supervisor) => {
    localStorage.setItem('is_supervisor', is_supervisor)
}

export const removeIsSupervisor = () => {
    localStorage.removeItem('is_supervisor')
}

export const getIsOwner = () => {
    const is_owner = localStorage.getItem('is_owner')
    return is_owner ?? 0
}

export const setIsOwner = (is_owner) => {
    localStorage.setItem('is_owner', is_owner)
}

export const removeIsOwner = () => {
    localStorage.removeItem('is_owner')
}

export const getParameter = (param_key) => {
    const parameter_str = localStorage.getItem('parameter')

    const parameters = parameter_str ? JSON.parse(parameter_str) : null
    var selectedParameter 
    
    if (parameters !== null) {
        selectedParameter = parameters.find(item => item.param_key == param_key)
    }
    return selectedParameter?.param_value ?? null
}

export const setParameter = (parameter) => {
    localStorage.setItem('parameter', JSON.stringify(parameter))
}

export const removeParameter = () => {
    localStorage.removeItem('parameter')
}

export const getGenericSupplier = () => {
    const supplier_str = localStorage.getItem('supplier')

    try {
        const suppliers = JSON.parse(supplier_str);
        console.log(suppliers);
        return suppliers
    } catch (err) {
        console.log('Error: ', err.message);
        return [{}]
    }
}

export const setGenericSupplier = (supplier) => {
    localStorage.setItem('supplier', JSON.stringify(supplier))
}

export const removeBranchList = () => {
    localStorage.removeItem('branch_list')
}

// 290726 (penegasan user): SEMUA pilihan/filter outlet urut ASCENDING by id.
// Diterapkan di sumbernya (getBranchList & getBranchListForFilter) supaya setiap
// halaman ikut tanpa perlu sort sendiri-sendiri. Selalu pada SALINAN — array dari
// localStorage/parse tidak boleh dimutasi di tempat.
export const sortBranchesByIdAsc = (list) =>
    (Array.isArray(list) ? [...list] : []).sort((a, b) => (Number(a?.id) || 0) - (Number(b?.id) || 0))

export const getBranchList = () => {
    const branch_list_str = localStorage.getItem('branch_list')

    try {
        const branch_lists = JSON.parse(branch_list_str);
        return sortBranchesByIdAsc(branch_lists)
    } catch (err) {
        console.log('Error: ', err.message);
        return [{}]
    }
}

export const setBranchList = (branch_list) => {
    localStorage.setItem('branch_list', JSON.stringify(branch_list))
}

// ── all_branch_list (250726, permintaan user) ────────────────────────────────
// DAFTAR SEMUA outlet, di-set saat login HANYA untuk user yang boleh memfilter
// semua outlet entitasnya (super atau node outlet.filter-entity — lihat loader
// main.js). Dipakai getBranchListForFilter() supaya filter outlet (mis. laporan)
// mencakup SEMUA outlet se-entitas, bukan hanya outlet yang di-assign ke user.
// Kosong/absen utk user biasa → perilaku lama (outlet assigned).
export const setAllBranchList = (branch_list) => {
    try {
        localStorage.setItem('all_branch_list', JSON.stringify(branch_list ?? []))
    } catch (err) {
        // ignore quota / serialization errors
    }
}

export const getAllBranchList = () => {
    try {
        return JSON.parse(localStorage.getItem('all_branch_list'))
    } catch (err) {
        return null
    }
}

export const removeAllBranchList = () => {
    localStorage.removeItem('all_branch_list')
}

// Outlet konsinyasi yoiboi tidak boleh muncul di filter-by-outlet
export const YOIBOI_OUTLET_CODE = 'yoiboi'

// Entity (ATALLA/VISION) dari branch yang sedang dipilih user. Dipakai untuk
// memisahkan data antar-entitas: dewi-at hanya lihat outlet ATALLA, dewi-vs VISION.
export const getCurrentEntity = () => {
    try {
        const current = getCurrentBranch()
        if (current?.entity) return current.entity
        // 290726: current_branch bisa tersimpan SEBELUM kolom entity ada (sesi login
        // lama) → entity null padahal branch-nya jelas. Fallback: cari branch yang
        // sama di branch_list (di-refresh tiap login) dan pakai entity dari sana.
        // Tanpa ini, default satuan per-entitas (ATALLA→LSN) diam-diam jatuh ke PCS.
        if (current?.id) {
            const match = (getBranchList() || []).find(
                (b) => String(b?.id) === String(current.id)
            )
            if (match?.entity) return match.entity
        }
        return null
    } catch (err) {
        return null
    }
}

export const getBranchListForFilter = () => {
    // 250726 (permintaan user): user yang boleh filter semua outlet entitasnya
    // (super / node outlet.filter-entity) → all_branch_list terisi saat login →
    // pakai SEMUA outlet, lalu di-entity-filter (cross-entity tetap disembunyikan).
    // User biasa: all_branch_list kosong → pakai outlet assigned (perilaku lama).
    const all = getAllBranchList()
    const list = (Array.isArray(all) && all.length) ? all : getBranchList()
    if (!Array.isArray(list)) return list

    const currentEntity = getCurrentEntity()

    return sortBranchesByIdAsc(list).filter((branch) => {
        if (String(branch?.code ?? '').toLowerCase() === YOIBOI_OUTLET_CODE) return false
        // Strict separation: bila entity user diketahui, sembunyikan outlet entity lain.
        // Bila belum ada data entity (pra-migrasi), jangan filter agar perilaku lama aman.
        if (currentEntity && branch?.entity && branch.entity !== currentEntity) return false
        return true
    })
}

// ── Grup filter outlet (permintaan user 240726) ──────────────────────────────
// Semua dropdown filter outlet menampilkan 2 grup + outlet individual:
//   1. "Semua Outlet" = outlet entitas user & is_ho=0 (di luar grup HO).
//   2. "HO"           = outlet HO tetap (PT Atalla 1 + Gudang Titip Pabrik 15).
// Outlet individual diurutkan ascending by id. Grup adaptif per-entitas: dibangun
// dari getBranchListForFilter() (sudah ter-scope akses + entitas user).
export const HO_OUTLET_IDS = [1, 15]

// Sentinel value opsi grup (dipakai di <select> & URL searchParams).
export const OUTLET_GROUP_ALL = 'GRP_ALL'
export const OUTLET_GROUP_HO = 'GRP_HO'

const isHoGroupOutlet = (branch) => HO_OUTLET_IDS.includes(Number(branch?.id))

/**
 * Outlet "pusat": ber-flag is_ho, atau HO Atalla (1) / Gudang Titip Pabrik (15)
 * / Vision One (14). Selain itu = outlet toko, yang hanya boleh melihat datanya
 * sendiri (pembelian, penerimaan, retur, koreksi stok, stok, laporan).
 */
export const isHoBranch = (branch) =>
    Boolean(Number(branch?.is_ho)) || [1, 14, 15].includes(Number(branch?.id))

/**
 * CORE: bangun opsi grup+individual dari daftar branch apa pun.
 * @param {Array} branches sumber outlet (mis. getBranchListForFilter, atau allOutlets
 *   unrestricted utk list pembelian yang memang lintas-entitas).
 * @param {?string} semuaEntity bila di-set, grup "Semua Outlet" DIBATASI ke entitas itu
 *   (adaptif per-user); null = semua non-HO (lintas-entitas). Outlet individual & grup HO
 *   SELALU mengikuti `branches` apa adanya (jadi list pembelian bisa memuat outlet 1/HO
 *   Atalla walau user Vision).
 */
export const buildOutletFilterOptions = (branches, semuaEntity = null) => {
    const list = (branches || [])
        .filter((b) => b && b.id != null && String(b.code ?? '').toLowerCase() !== YOIBOI_OUTLET_CODE)
        .slice()
        .sort((a, b) => Number(a.id) - Number(b.id))

    // Outlet toko (non-HO) DIKUNCI ke outlet sendiri: dropdown hanya berisi satu
    // opsi (outlet user login), tanpa grup "Semua Outlet"/"HO". Berlaku untuk
    // semua layar yang memakai filter outlet.
    const currentBranch = getCurrentBranch()
    if (currentBranch?.id && !isHoBranch(currentBranch)) {
        const own = list.find((b) => String(b.id) === String(currentBranch.id)) || currentBranch
        return [{ value: String(own.id), label: own.name, kind: 'outlet', ids: [Number(own.id)] }]
    }

    const inEntity = (b) => !semuaEntity || (b.entity && b.entity === semuaEntity)
    const semuaIds = list
        .filter((b) => inEntity(b) && Number(b.is_ho) !== 1 && !isHoGroupOutlet(b))
        .map((b) => Number(b.id))
    const hoIds = list
        .filter((b) => isHoGroupOutlet(b))
        .map((b) => Number(b.id))

    const options = []
    if (semuaIds.length) options.push({ value: OUTLET_GROUP_ALL, label: 'Semua Outlet', kind: 'group', ids: semuaIds })
    if (hoIds.length) options.push({ value: OUTLET_GROUP_HO, label: 'HO', kind: 'group', ids: hoIds })
    for (const b of list) {
        options.push({ value: String(b.id), label: b.name, kind: 'outlet', ids: [Number(b.id)] })
    }
    return options
}

/**
 * Opsi standar (entity-scoped): [Semua Outlet, HO, ...outlet asc-by-id] dari
 * getBranchListForFilter(). Grup hanya muncul bila anggotanya ada.
 */
export const getOutletFilterOptions = () => buildOutletFilterOptions(getBranchListForFilter(), getCurrentEntity())

/**
 * Nilai default "ikut outlet user" dari daftar opsi + id outlet user:
 *  - outlet ∈ {1,15}                → grup HO
 *  - outlet anggota grup "Semua Outlet" (toko biasa) → grup Semua Outlet
 *  - outlet khusus lain (mis. Vision HO id14)        → outlet-nya sendiri
 */
export const getDefaultOutletFilterValueFrom = (options, ownId) => {
    const has = (v) => options.some((o) => o.value === v)
    const semua = options.find((o) => o.value === OUTLET_GROUP_ALL)
    const own = ownId != null && ownId !== '' ? Number(ownId) : null

    if (own != null && HO_OUTLET_IDS.includes(own) && has(OUTLET_GROUP_HO)) return OUTLET_GROUP_HO
    if (own != null && semua && semua.ids.includes(own)) return OUTLET_GROUP_ALL
    if (own != null && has(String(own))) return String(own)
    if (has(OUTLET_GROUP_ALL)) return OUTLET_GROUP_ALL
    return options[0]?.value ?? ''
}

export const getDefaultOutletFilterValue = () =>
    getDefaultOutletFilterValueFrom(getOutletFilterOptions(), getCurrentBranch()?.id)

/**
 * Resolusi nilai filter → parameter request, terhadap daftar opsi tertentu.
 * Grup → branch_list (daftar id) + outlet_id_csv; individual → outlet_id tunggal.
 * @returns {{ outlet_id: string, branch_list: number[], outlet_id_csv: string }}
 */
export const resolveOutletFilterWith = (value, options) => {
    const found = options.find((o) => String(o.value) === String(value))
    if (!found) {
        const all = options.filter((o) => o.kind === 'outlet').map((o) => o.ids[0]).filter(Boolean)
        return { outlet_id: '', branch_list: all, outlet_id_csv: '' }
    }
    if (found.kind === 'group') {
        return { outlet_id: '', branch_list: found.ids, outlet_id_csv: found.ids.join(',') }
    }
    return { outlet_id: String(found.value), branch_list: [Number(found.value)], outlet_id_csv: String(found.value) }
}

export const resolveOutletFilter = (value) => resolveOutletFilterWith(value, getOutletFilterOptions())

export const removeGenericSupplier = () => {
    localStorage.removeItem('supplier')
}

export const checkPhoneValid = (phone) => {
    if (phone === undefined || phone === null || phone === '' || phone === 'WALKIN') {
        return false
    } else {
        return true
    }
}

export const sendViaWA = async (phone, message) => {
    const maxchat_api = getParameter("MAXCHAT_ID_API_MESSAGE")

    if (!maxchat_api || maxchat_api == '') {
        toast.error("Pengiriman lewat WA belum tersedia!!")
        return
    }

    const checkNumber = (phone) => {
        if (phone.toString().substring(0,2) === "08") {
            phone = "628" +  phone.toString().substring(2)
        } else if (phone.toString().substring(0,2) === "+6")  {
            phone = phone.toString().substring(1)
        }
        return phone
    }

    if (!checkPhoneValid(phone)) {
        toast.error("Phone Number not valid!")
        return false
    }

    toast.loading("Sending WA...", {
        id: "submit"
    })
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    await axios.post(`${maxchat_api}`, {
        "to": checkNumber(phone),
        "type": "text",
        "text": message,
        "useTyping": false
    }, 
    {headers:  
    {
        'Authorization': `Bearer ${process.env.REACT_APP_MAXCHAT_ID}` 
    }
    }).then((response) => {
        if (response.data.status === "pending" || response.data.status === "delivered" || response.data.status === "queue") {
            toast.success("WA sent!", {
                id: "submit"
            })
        } else {
            toast.error(response.data.message, {
                id: "submit"
            })
        }         
    }).catch(error => {
        toast.error(JSON.stringify(error.response.data), {
            id: "submit"
        })
        console.log(error)
    })    
}

export const getMinimumDiscount = (a, b) => {
    if (b == 0 || !b) {
        return a
    }
    if (a == 0 || !a) {
        return b
    }
    if (Number(a) < Number(b)) {
        return Number(a)
    } else {
        return Number(b)
    }
}

// Laravel ValidationException mengembalikan { message: "The given data was invalid", errors: { field: [...] } }.
// Kalau frontend cuma baca .message, user lihat pesan generic "invalid provided data" — pesan spesifik
// hilang. Helper ini surface pesan spesifik dari .errors kalau ada, else fallback ke .message.
export const extractApiErrorMessage = (err, fallback = "Terjadi kesalahan") => {
    const data = err?.response?.data
    const validationErrors = data?.errors
    if (validationErrors && typeof validationErrors === "object") {
        const flat = Object.values(validationErrors).flat().filter(Boolean)
        if (flat.length > 0) return String(flat[0])
    }
    return data?.message || err?.message || fallback
}